export const GET_PATIENT_SMS_LOGS = 'patientSmsLogs/getPatientSmsLogs'
export const SEND_PATIENT_SMS = 'patientSmsLogs/sendPatientSms'
